<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <!-- <v-tooltip bottom> -->
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <span>{{$t('close')}}</span> -->
          <!-- </v-tooltip> -->
          <v-toolbar-title>{{ json_data.save_type == "create" ? $t("menu.IncomeCreate") : $t("menu.IncomeEdit") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-3>
            <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('effective_date')" type="date" v-model="form_model.add_date" :rules="form_rules.add_date" required hide-details />
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-autocomplete
                        hide-details
                        :loading="loading"
                        v-model="form_model.emp_code"
                        :items="Employee_List"
                        item-text="name"
                        item-value="code"
                        :label="$t('employee_code')"
                        allow-overflow
                        append-icon="search"
                        clearable
                        required
                        :rules="form_rules.emp_code"
                      />
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('amount')" v-model="form_model.amount" :rules="form_rules.amount" required type="number" hide-details />
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-select :items="tax_type" :label="$t('TaxType')" v-model="form_model.tax_type" item-text="text" item-value="code"></v-select>
                    </v-flex>
                    <!-- <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('TaxPercent')" v-model="form_model.tax_percent" required type="number" hide-details />
                    </v-flex> -->
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-select :items="branch_items" :label="$t('branch_pay')" item-text="name" item-value="code" v-model="form_model.branch_pay" />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-checkbox :label="$t('not_cal_tax')" value="1" v-model="form_model.not_cal_tax" />
                    </v-flex>
                    <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-checkbox label="รวมรายได้ในประกันสังคม"   :value="1" v-model="form_model.not_cal_ss" />
                    </v-flex>
                    <!-- <v-flex lg4 md6 sm6 xs12 pa-1>
                      <v-checkbox :label="$t('company_pay')" value="1" v-model="form_model.company_pay" />
                    </v-flex> -->
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea :label="$t('remark')" v-model="form_model.name" :rules="form_rules.name" required hide-details />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
        this.form_model.trans_flag = val.data.trans_flag.toString();
      } else {
        this.$refs.form.resetValidation();
      }
    },
  },
  data: () => ({
    form_valid: false,
    branch_items: [],
    form_model: {
      branch_pay: "",
      emp_code: "",
      trans_flag: "0",
      name: "",
      amount: "0",
      tax_type: "1",
      tax_percent: 0,
      not_cal_tax: "0",
      not_cal_ss: 0 ,
      company_pay: "0",
      add_date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      company_id : localStorage._company_guid,
    },
    form_rules: {
      amount: [(v) => !!v || "do not empty."],
      add_date: [(v) => !!v || "do not empty."],
      emp_code: [(v) => !!v || "do not empty."],
    },
    tax_type: [
      { code: "1", text: "มาตรา40(1) ค่าจ้างเงินเดือน" },
      { code: "2", text: "มาตรา40(2) ค่านายหน้า ค่าคอม" },
      // { code: "3", text: "มาตรา40(3) ค่าลิขสิทธิ์" },
      // { code: "4", text: "มาตรา40(4) ดอกเบี้ยเงินปันผล" },
      // { code: "5", text: "มาตรา40(5) ค่าเช่า" },
      // { code: "6", text: "มาตรา40(6) ค่าวิชาชีพอิสระ" },
      // { code: "7", text: "มาตรา40(7) ค่ารับเหมา" },
      // { code: "8", text: "มาตรา40(8) เงินได้อื่นๆ" },
    ],
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
  }),
  created: function() {
    this.getEmployee("newData");
    this.getProfileBranchList();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;

          //console.log(this.branch_items);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    clearForm() {
      this.form_model = {
        emp_code: "",
        trans_flag: "0",
        name: "",
        amount: "0",
        tax_type: "1",
        tax_percent: 0,
        not_cal_tax: "0",
        not_cal_ss:0,
        company_pay: "0",
        add_date: new Date().toISOString().slice(0, 10),
        creator_code: localStorage._usercode,
        company_id : localStorage._company_guid,
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    onSave() {
      if(this.form_model.not_cal_tax == null || this.form_model.not_cal_tax == "" || this.form_model.not_cal_tax == undefined){
        this.form_model.not_cal_tax = "0";
      }
      console.log(this.form_model);
     
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        DocumentService.createIncomeandExpenses(this.form_model)
          .then((res) => {
            this.showSnackBar(this.$t("message.save"), "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdate() {
      if(this.form_model.not_cal_tax == null || this.form_model.not_cal_tax == "" || this.form_model.not_cal_tax == undefined ){
        this.form_model.not_cal_tax = "0";
      }
      
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        DocumentService.updateIncomeandExpenses(this.form_model)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
  },
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
.v-card__text {
  padding: 0px !important;
}
</style>
